import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { LanguageToggle } from "@/components/LanguageToggle";
import { useI18n } from "@/contexts/I18nContext";

export function PublicHeader({ subtitle }) {
  const { t } = useI18n();
  return (
    <header className="sticky top-0 z-40 border-b border-border/60 bg-background/90 backdrop-blur supports-[backdrop-filter]:bg-background/70 pt-safe">
      <div className="mx-auto flex max-w-md items-center justify-between gap-3 px-4 py-3">
        <Link to="/" className="flex items-center gap-3 group" data-testid="public-header-logo-link">
          <Logo size={40} />
          <div className="leading-tight">
            <p className="font-serif-display text-base font-semibold tracking-tight">{t.appName}</p>
            {subtitle && <p className="text-xs text-muted-foreground">{subtitle}</p>}
          </div>
        </Link>
        <LanguageToggle />
      </div>
    </header>
  );
}
